<mat-form-field
  appearance="outline"
  class="{{ formFieldClass }}"
  [ngClass]="{ 'mat-form-field-readonly': readonly }"
>
  <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
    "duration.title" | translate
  }}</mat-label>
  <mat-select [formControl]="control">
    <mat-option [value]="null">- -</mat-option>

    <mat-option *ngFor="let duration of getDurations()" [value]="duration">
      {{ "duration." + duration | translate }}
    </mat-option>
  </mat-select>
  <mat-error *ngIf="control.invalid && control.touched && required">
    {{ "experiences.required-duration" | translate }}
  </mat-error>
</mat-form-field>
